import {createContext} from "react";
import {getDefaultLocale} from './helpers/localeHelpers';

const LocaleContext = createContext(getDefaultLocale().name);

export default LocaleContext;
